export default __webpack_public_path__ + "drill.png?99103aa2c2bfb47dae137224983c3705";